import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import BranchTableFilter from './components/BranchTableFilter'
import BranchTable from './components/BranchTable'
import BranchStatistics from './components/BranchStatistics'
import {selectBranchList} from './redux/BranchRedux'
import {BranchModel} from './models/BranchModel'
import { useAppSelector } from '../../../setup/redux/hooks'

type Props = {
  className: string
}
const BranchPage: FC<Props> = (props) => {
  const intl = useIntl()

  const data: BranchModel[] = useAppSelector(selectBranchList)
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'BRANCH.PAGE_TITLE'})}</PageTitle>
      {data.length > 0 && <BranchStatistics />}
      <div className='card mb-10'>
        <BranchTableFilter />
        <div className='card-body p-10'>
          <BranchTable />
        </div>
      </div>
    </>
  )
}

export default BranchPage
